import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./AiReports.css";

import ReportsHeader from "./components/ReportsHeader";
import AnalysisContextPanel from "./components/AnalysisContextPanel";
import ChatContainer from "./components/ChatContainer";

const AiReports = () => {
  const navigate = useNavigate();
  const [analysisContext, setAnalysisContext] = useState({
    analysisType: "",
    branch: null,
    device: null,
    metric: null,
    calculatedParameter: null,
    period: {
      mode: "month",
      month: "",
      startDate: "",
      endDate: "",
    },
  });
  const [chatSendHandler, setChatSendHandler] = useState(null);

  const handleContextChange = useCallback((newContext) => {
    setAnalysisContext(newContext);
  }, []);

  const registerChatSendHandler = useCallback((sendFn) => {
    setChatSendHandler(() => sendFn);
  }, []);

  const handleGenerateReport = useCallback(() => {
    if (typeof chatSendHandler === "function") {
      chatSendHandler("");
    }
  }, [chatSendHandler]);

  return (
    <>
      {/* Breadcrumb */}
      <div className="cont-path">
        <p className="path path-cursor" onClick={() => navigate("/")}>
          Dashboard {">"}
        </p>
        <p className="path">Informes IA</p>
      </div>

      {/* Página principal */}
      <div className="ai-reports-page">
        <div className="ai-reports-wrapper">
          {/* Header mejorado */}
          <ReportsHeader />

          <div className="ai-reports-main-layout">
            {/* Panel de contexto (sidebar izquierdo) - Ahora configurable */}
            <aside className="ai-reports-sidebar">
              <AnalysisContextPanel
                onContextChange={handleContextChange}
                onGenerateReport={handleGenerateReport}
              />
            </aside>

            {/* Área principal de conversación */}
            <main className="ai-reports-main-area">

              {/* Contenedor del chat */}
              <ChatContainer
                analysisContext={analysisContext}
                onRegisterSend={registerChatSendHandler}
              />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiReports;
